/**
 * Filtro e ricerca dei paesi. Nessun DOM: opera sul payload che il server
 * emette nella pagina, e sulle voci della lista lette dai loro data attribute.
 *
 * Usa `export` ESM e non `module.exports`: webpack tratta questi file come
 * harmony module, dove `module.exports` e' read-only e in produzione fa
 * abortire l'intero bundle.
 */

const MIN_MATCH_LENGTH = 2;

function haystack(entry) {
  return [entry.name].concat(entry.aliases || []);
}

/**
 * Predicato unico condiviso da mappa e lista. Un'entry senza continente passa
 * finche' non si filtra per continente: non deve sparire dalla pagina.
 */
export function matchesFilters(entry, filters) {
  const continent = (filters && filters.continent) || '';
  const query = ((filters && filters.query) || '').trim().toLowerCase();

  if (continent && entry.continent !== continent) {
    return false;
  }

  if (!query) {
    return true;
  }

  return haystack(entry).some((value) => value.toLowerCase().indexOf(query) !== -1);
}

/**
 * ~138 PAESI nel payload (non righe di questo file): un filter() lineare
 * basta, non serve un indice ne' una chiamata di rete.
 */
export function filterCountries(countries, filters) {
  return countries.filter((country) => matchesFilters(country, filters));
}

/**
 * Il paese su cui inquadrare la mappa mentre si digita. Richiede il prefisso e
 * almeno due caratteri: con uno solo la mappa saltellerebbe a ogni tasto.
 */
export function findBestMatch(countries, query) {
  const needle = (query || '').trim().toLowerCase();

  if (needle.length < MIN_MATCH_LENGTH) {
    return null;
  }

  const match = countries.find((country) =>
    haystack(country).some((value) => value.toLowerCase().indexOf(needle) === 0));

  return match || null;
}
